gsap.registerPlugin(ScrollTrigger);

document.querySelectorAll(".kg-text-content").forEach((section, index) => {
  const sectionId = `.section-${index + 1}`; 

  // Set the ScrollTrigger and animation for each section
  gsap.timeline({
    scrollTrigger: {
      trigger: section, 
      start: "top 80%",
      end: "bottom bottom",
      toggleActions: "play none none reverse"
    }
  })
  .from(`${sectionId} h2.kg-text-h2`, { opacity: 0, y: 20, duration: 1 }) 
  .from(`${sectionId} p.kg-text-p`, { opacity: 0, y: 20, duration: 1 }, "-=0.5"); 
});
